import React from "react";
import styles from "./index.module.scss";

const PhotoWallSection = ({ photoWallSectionData }) => {

  if (!photoWallSectionData) return null;
  const images = photoWallSectionData.images || [];

  if (!Array.isArray(images) || images.length === 0) {
    return null;
  }

  return (
    <section className={`${styles.photoWallSection} ${styles.backgroundGrey}`}>
      <div className={styles.socialContent}>
        <div className={styles.socialTiles}>
          <div className={styles.socialTileSizer} />
          {images.map((item) => {
            if (!item?.fields) return null;
            const { imageUrl, internalTitle } = item.fields;
            if (!imageUrl) return null;
            return (
              <div
                key={item.sys?.id ?? imageUrl}
                className={styles.socialTile}
              >
                <div className={styles.socialImage}>
                    <img
                    src={imageUrl}
                    alt={internalTitle || "Kohler photo wall image"}
                    loading="lazy"
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PhotoWallSection;
